import { CensusFileRowGridData } from '../types/census-file-row-grid-data'
import { CensusFileRowDto } from '../api/dto/census-file-row.dto'
import { CensusFileMemberUpdatesSchema } from '../api/dto/census-file-member-updates-schema.dto'

// Update `rowData` with updated data. Return CensusFileRowDto for use in update endpoint.
export const mapGridDataToCensusFileRowDto = (
  gridDataRow: CensusFileRowGridData,
  includeMemberUpdates = false
): CensusFileRowDto => ({
  rowData: Object.keys(gridDataRow.rowData).reduce((acc, key) => {
    if (key in gridDataRow) acc[key] = gridDataRow[key]
    return acc
  }, {}),
  id: gridDataRow.id,
  censusFileId: gridDataRow.censusFileId,
  clientPublicKey: gridDataRow.clientPublicKey,
  firstName: gridDataRow.FirstName || gridDataRow.firstName,
  lastName: gridDataRow.LastName || gridDataRow.lastName,
  rowNumber: gridDataRow.rowNumber,
  employeeId: gridDataRow.employeeId,
  type: gridDataRow.type,
  status: gridDataRow.status,
  updates: gridDataRow.updates ?? null,
  ...(includeMemberUpdates && gridDataRow.updates
    ? { memberUpdates: getMemberUpdates(gridDataRow) }
    : {}),
})

function getMemberUpdates(gridDataRow: CensusFileRowDto) {
  const memberUpdates: CensusFileMemberUpdatesSchema =
    gridDataRow.memberUpdates ?? {}
  if (!gridDataRow.updates || gridDataRow.updates === null) {
    return memberUpdates
  }

  Object.entries(gridDataRow.updates.updateFields).forEach(
    ([key, value]: [string, any]) => {
      const mappedField = toStrictCamelCase(
        key
      ) as keyof CensusFileMemberUpdatesSchema
      memberUpdates[mappedField] = value.newValue
    }
  )
  return memberUpdates
}

function toStrictCamelCase(str: string): string {
  if (/^[A-Z]+$/.test(str)) return str.toLowerCase()

  return str
    .replace(/^[A-Z]/, (c) => c.toLowerCase())
    .replace(/[_-](\w)/g, (_, c) => c.toUpperCase())
}
